import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

type ArrowPopperStyleProps = {
	color: string;
};

export const useStyles = makeStyles(theme => ({
	popper: {
		width: 350,
		zIndex: 1500,
		fontSize: 14,
		borderRadius: 3,
		backgroundColor: ({ color }: ArrowPopperStyleProps) => color,

		'&[x-placement*="bottom"] .arrow': {
			width: 0,
			height: 0,
			borderLeft: '1em solid transparent',
			borderRight: '1em solid transparent',
			borderBottom: ({ color }: ArrowPopperStyleProps) => `1em solid ${color}`,
			marginTop: '-0.9em'
		},

		'&[x-placement*="top"] .arrow': {
			bottom: 0,
			width: 0,
			height: 0,
			borderLeft: '1em solid transparent',
			borderRight: '1em solid transparent',
			borderTop: ({ color }: ArrowPopperStyleProps) => `1em solid ${color}`,
			marginBottom: '-0.9em'
		},

		'&[x-placement*="left"] .arrow': {
			right: 0,
			width: 0,
			height: 0,
			borderTop: '1em solid transparent',
			borderBottom: '1em solid transparent',
			borderLeft: ({ color }: ArrowPopperStyleProps) => `1em solid ${color}`,
			marginRight: '-0.9em'
		},

		'&[x-placement*="right"] .arrow': {
			left: 0,
			width: 0,
			height: 0,
			borderTop: '1em solid transparent',
			borderBottom: '1em solid transparent',
			borderLeft: ({ color }: ArrowPopperStyleProps) => `1em solid ${color}`,
			marginLeft: '-0.9em'
		}
	},
	popperContent: {
		padding: 10
	},
	arrow: {
		position: 'absolute',
		fontSize: 7,
		width: '3em',
		height: '3em',
		zIndex: 1500
	}
}));
